module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header-section', {
    attrs: {
      "title": "BC Legal - ABC Quantum",
      "set-position": "fixed",
      "current": this.current,
      "load-button": true,
      "save-button": true,
      "create-button": true,
      "set-border": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "o-content ie u-position-relative",
    attrs: {
      "id": "app"
    }
  }, [(_vm.isVisible()) ? _c('div', [_c('timeline', {
    attrs: {
      "steps": this.steps,
      "current": this.current,
      "stepNo": this.stepNo,
      "timeline-steps": "nine"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "o-content__mob-main-column"
  }, [_c('router-view')], 1)], 1) : _c('div', {
    staticClass: "a-loader--big__container"
  }, [_c('div', {
    staticClass: "a-loader--big"
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-772dd47b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/personal-injury-claims/PersonalInjuryClaims.vue
// module id = 1750
// module chunks = 0